export interface HashTable<T> {
  [key: string]: T;
}

export enum FeatureFlags {
  CredentialsSSO = 'spa-credentials-sso',
  mobileMessagingSpaOnlyTwilio = 'mobile-messaging-spa-only-twilio',
  MobileMessagingV2 = 'mobile-messaging-v2',
}
